<template>
  <hm-content title>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >新增一级代理</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          style="width:220px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入代理人姓名/电话"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        lazy
        :load="load"
        :tree-props="{ hasChildren: 'isParent' }"
        row-key="shareAgentId"
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="agentName"
          label="代理人名称"
          width="100"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="agentPhone"
          label="代理人电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="Level"
          label="代理人级别"
        >
          <template slot-scope="scope">{{ scope.row.Level }}级代理</template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberNum"
          label="下属分销会员数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="agentTitleId"
          label="代理头衔"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="scope.row.disabled"
              clearable
              v-model="scope.row.agentTitleId"
              placeholder="请选择代理头衔"
              size="small"
              filterable
              class="mr10"
            >
              <el-option
                :label="v.titleName"
                :value="v.agentTitleId"
                v-for="(v, i) in AgentTitleList"
                :key="i"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="parentRewardRatio"
          header-align="center"
          align="center"
          width="100"
          label="分得上级代理奖励比例"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-input
                :disabled="scope.row.disabled"
                v-model="scope.row.parentRewardRatio"
                @input="
                  filterGt0OrFixed2(
                    'parentRewardRatio',
                    scope.$index,
                    scope.row
                  )
                "
                clearable
                style="width:70px;"
                placeholder="请输入比例"
                size="small"
                class="ipt mr10"
              ></el-input>
              <div class="flex flex-center item-center">%</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="150"
          label="代理店铺名"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-input
                :disabled="scope.row.disabled"
                v-model="scope.row.agentShopName"
                clearable
                placeholder="请输入店铺名"
                size="small"
                class="ipt mr10"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="店铺logo">
          <template slot-scope="scope">
            <div
              class="flex flex-center agent-img-wrapper"
              @click="changeListItemBg(scope.row, 'listItemAgentLogo')"
            >
              <el-image
                style="width: 100px;"
                :src="scope.row.agentLogo"
                :preview-src-list="
                  scope.row.disabled ? [scope.row.agentLogo] : []
                "
              ></el-image>
              <div class="tips" v-show="!scope.row.disabled">更换图片</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="店铺背景">
          <template slot-scope="scope">
            <div
              class="flex flex-center agent-img-wrapper"
              @click="changeListItemBg(scope.row, 'listItemAgentBgp')"
            >
              <el-image
                style="width: 100px;"
                :src="scope.row.agentBgp"
                :preview-src-list="
                  scope.row.disabled ? [scope.row.agentBgp] : []
                "
              ></el-image>
              <div class="tips" v-show="!scope.row.disabled">更换图片</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actualRewardRatio"
          label="实际奖励比例"
        >
          <template slot-scope="scope"
            >{{ scope.row.actualRewardRatio }}%</template
          >
        </el-table-column>

        <el-table-column
          label="操作"
          width="220"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="adjustment(scope.row)"
                >关系调整</el-button
              >
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="addLowerLevel(scope.row)"
                >新增下级</el-button
              >
              <el-button
                @click="edit(scope.row, scope.$index)"
                size="small"
                class="blue"
                type="text"
                >{{ scope.row.disabled ? "编辑" : "保存" }}</el-button
              >
              <el-button
                :disabled="scope.row.isParent"
                @click="deleteAgent(scope.row)"
                size="small"
                class="danger"
                type="text"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1200px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div>
        <div class="mb10 flex flex-wrap" v-if="type === 'lowerLv'">
          <div class="agent mr10 flex item-center flex-end" style="width:60px;">
            上级代理
          </div>
          <div class="flex item-center">
            <span class="mr20">代理名称：{{ parentRow.agentName }}</span>
            <span class="mr20">电话号码：{{ parentRow.agentPhone }}</span>
            <span class="mr10"
              >实际奖励比例：{{ parentRow.actualRewardRatio }}%</span
            >
          </div>
        </div>
        <div
          class="mb10 flex flex-wrap"
          v-if="type === 'add' || type === 'lowerLv'"
        >
          <div
            class="agent mr10 flex item-center flex-end"
            style="width:60px;height:32px"
          >
            代理人
          </div>
          <div>
            <el-input
              clearable
              style="width:300px"
              v-model.trim="keyWord"
              :placeholder="placeholder"
              size="small"
              class="ipt mr10"
            >
              <el-select
                slot="prepend"
                size="small"
                style="width:100px"
                @change="selectQueryType"
                v-model="queryType"
              >
                <el-option label="手机号" value="memberMobile"></el-option>
                <!-- <el-option label="会员名称" value="memberName"></el-option> -->
              </el-select>
            </el-input>
            <!-- <el-input
              clearable
              style="width:220px"
              v-model.trim="keyWord"
              placeholder="请输入电话号码/名字"
              size="small"
              class="ipt mr10"
            ></el-input>-->

            <el-button
              type="primary"
              size="small"
              @click="searchMember"
              :disabled="keyWord === ''"
              >查询</el-button
            >
            <el-button type="primary" size="small" @click="createdMember" plain
              >新建会员</el-button
            >
            <div class="form-item-tip mt10">
              1.代理人的添加将会导致分销关系的变化，在添加或变化代理人所属关系时建议先线下沟通。
            </div>
            <div class="form-item-tip">
              2.一级代理的设置直接按照下属分销人员获
            </div>
            <div
              class="member-body flex flex-wrap item-center"
              v-for="(v, i) in memberInfo"
              :key="i"
            >
              <div class="agent flex-1">{{ v.memberName }}</div>
              <div class="agent flex-1">{{ v.memberMobile }}</div>
              <el-button
                type="text"
                size="small"
                class="blue flex-1"
                @click="confirmAdd(v)"
                >确认添加</el-button
              >
            </div>
          </div>
        </div>
        <div class="table" v-if="type === 'add' || type === 'lowerLv'">
          <el-table
            stripe
            border
            :data="addAgentList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="agentName"
              label="会员名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="agentPhone"
              label="会员电话"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="agentTitleId"
              label="选择代理头衔"
              width="200"
            >
              <template slot-scope="scope">
                <el-select
                  clearable
                  v-model="scope.row.agentTitleId"
                  placeholder="请选择返拥级数"
                  size="small"
                  filterable
                  class="mr10"
                >
                  <el-option
                    :label="v.titleName"
                    :value="v.agentTitleId"
                    v-for="(v, i) in AgentTitleList"
                    :key="i"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              v-if="type === 'add'"
              header-align="center"
              align="center"
              prop="actualRewardRatio"
              width="200"
              label="实际奖励比例"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                    v-model="scope.row.actualRewardRatio"
                    @input="
                      filterGt0OrFixed222('actualRewardRatio', scope.$index)
                    "
                    clearable
                    style="width:130px;"
                    placeholder="请输入比例"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                  <div class="flex flex-center item-center">%</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="type === 'lowerLv'"
              prop="parentRewardRatio"
              header-align="center"
              align="center"
              width="200"
              label="分得上级代理奖励比例"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                    @change="
                      changeRatio(scope.row.parentRewardRatio, scope.$index)
                    "
                    v-model="scope.row.parentRewardRatio"
                    @input="
                      filterGt0OrFixed222('parentRewardRatio', scope.$index)
                    "
                    clearable
                    style="width:130px;"
                    placeholder="请输入比例"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                  <div class="flex flex-center item-center">%</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="type === 'lowerLv'"
              header-align="center"
              align="center"
              prop="actualRewardRatio"
              label="实际奖励比例"
            >
              <template slot-scope="scope"
                >{{ scope.row.actualRewardRatio }}%</template
              >
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="代理店铺名"
              width="200px"
            >
              <template slot-scope="scope">
                <el-input
                  size="small"
                  placeholder="请输入代理店铺名"
                  v-model="scope.row.agentShopName"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="店铺logo"
            >
              <template slot-scope="scope">
                <div
                  class="agent-img-wrapper"
                  @click="changeBg(scope.row, 'agentLogo')"
                >
                  <img :src="scope.row.agentLogo" alt="店铺logo" />
                  <div class="tips">更换图片</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="店铺背景"
            >
              <template slot-scope="scope">
                <div
                  class="agent-img-wrapper"
                  @click="changeBg(scope.row, 'agentBgp')"
                >
                  <img :src="scope.row.agentBgp" alt="店铺背景" />
                  <div class="tips">更换图片</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    class="blue"
                    type="text"
                    @click="remove(scope.$index)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="type === 'isAdjustment'">
          <div
            class="flex flex-center item-center"
            style="height:100px;fontSize:16px;"
          >
            当前代理存在下级代理，请确认调整当前代理奖励比例是否关联调整下级代理奖励比例
          </div>
          <div class="flex flex-center" style="height:50px">
            <el-radio-group v-model="changeType" size="small">
              <el-radio label="notChange">保持不变</el-radio>
              <el-radio label="change">关联调整</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="type === 'adjustment'">
          <div class="modal-table mb20">
            <div class="table-header flex">
              <div class="flex-1">代理名称</div>
              <div class="flex-1">上级代理</div>
              <div class="flex-1">领取上级奖励比例</div>
              <div class="flex-1">实际奖励比例</div>
            </div>
            <div class="table-body flex">
              <div class="flex-1">{{ row.agentName }}</div>
              <div class="flex-1">
                {{ row.parentAgentName
                }}{{
                  row.parentAgentName === "-" || row.parentAgentPhone === "-"
                    ? ""
                    : "/"
                }}{{ row.parentAgentPhone }}
              </div>
              <div class="flex-1">{{ row.parentRewardRatio }}%</div>
              <div class="flex-1">{{ row.actualRewardRatio }}%</div>
            </div>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
          >
            <el-form-item label="关系调整" prop="relationshipAdjustment">
              <el-radio-group
                v-model="ruleForm.relationshipAdjustment"
                size="small"
                @change="relationshipAdjustmentChange"
              >
                <el-radio label="dingji">调整为顶层代理</el-radio>
                <el-radio label="shangji">更换上级代理</el-radio>
              </el-radio-group>
              <div v-if="ruleForm.relationshipAdjustment === 'shangji'">
                <div>
                  <el-input
                    clearable
                    style="width:220px"
                    v-model.trim="keyWord"
                    placeholder="请输入需要更换的上级代理电话"
                    size="small"
                    class="ipt mr10"
                    @input="filterGt0OrFixedMobile('keyWord')"
                  ></el-input>

                  <el-button
                    type="primary"
                    size="small"
                    @click="searchAgent"
                    :disabled="keyWord === '' || show"
                    >确认</el-button
                  >
                </div>
                <!-- <div class="mt10" v-for="(v, i) in memberInfo" :key="i">
                  <span class="mr10 agent">{{ v.memberName }}</span>
                  <span class="mr10 agent">{{ v.memberPhone }}</span>
                  <span class="mr10 agent">{{ v.memberPhone }}</span>
                  <el-button
                    type="text"
                    size="small"
                    class="primany"
                    @click="confirmAdd(v)"
                    >确认</el-button
                  >
                </div>-->
                <div
                  class="flex flex-wrap item-center"
                  v-for="(v, i) in memberInfo"
                  :key="i"
                >
                  <div class="agent mr20">{{ v.agentName }}</div>
                  <div class="agent mr20">{{ v.titleName }}</div>
                  <div class="agent mr20">
                    代理奖励:{{ v.actualRewardRatio }}%
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="奖励调整" prop="selfChangeType">
              <el-radio-group v-model="ruleForm.selfChangeType" size="small">
                <el-radio label="notChange">不改变实际奖励</el-radio>
                <el-radio label="change">按照新上级比例调整</el-radio>
              </el-radio-group>
              <div v-if="ruleForm.selfChangeType === 'change'">
                <el-input
                  clearable
                  style="width:220px"
                  @mousewheel.prevent.native
                  v-model.trim="ruleForm.singleGetcashUpperLimit"
                  @input="filterGt0OrFixed22('singleGetcashUpperLimit')"
                  placeholder="1到100"
                  size="small"
                  class="ipt mr10"
                ></el-input
                >%
              </div>
            </el-form-item>
            <el-form-item label="下级奖励调整" prop="changeType">
              <el-radio-group v-model="ruleForm.changeType" size="small">
                <el-radio label="notChange">不改变实际奖励</el-radio>
                <el-radio label="change">跟随当前代理调整</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button @click="save('ruleForm')" size="small" type="primary"
            >确 认</el-button
          >
          <el-button size="small" @click="handleClose">取 消</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="添加会员"
      :visible.sync="setMemberDialogVisible"
      custom-class="dialog"
    >
      <el-form
        :model="ruleFormMember"
        :rules="rules"
        ref="ruleFormMember"
        label-width="100px"
        class="product-ruleForm"
      >
        <el-form-item label="手机号：" prop="memberMobile">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleFormMember.memberMobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="memberName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleFormMember.memberName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日：" prop="memberBirthday">
          <el-date-picker
            v-model="ruleFormMember.memberBirthday"
            type="date"
            :picker-options="pickerOptions"
            start-placeholder="请选择出生年月日"
            end-placeholder="报名结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio-group v-model="ruleFormMember.memberSex">
            <el-radio label="men">男</el-radio>
            <el-radio label="women">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            type="textarea"
            v-model.trim="ruleFormMember.memberRemark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('ruleFormMember')"
            >提 交</el-button
          >
          <el-button size="small" @click="setMemberDialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      fileDir="decoration"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
  </hm-content>
</template>

<script>
// import { mapGetters } from "vuex";
import HmUpload from "@/components/HmUpload";

export default {
  components: {
    HmUpload
  },
  data() {
    const validatorFunc = function(rule, val, callback) {
      if (val === "change") {
        if (
          this.ruleForm.singleGetcashUpperLimit === "" ||
          this.ruleForm.singleGetcashUpperLimit > 100
        ) {
          return callback(new Error("请输入比例,1-100之间"));
        }
      }
      callback();
    }.bind(this);
    const adjustmentFunc = function(rule, val, callback) {
      if (val === "shangji") {
        if (!this.memberInfo.length > 0) {
          return callback(new Error("请选择要更换的上级代理"));
        }
      }
      callback();
    }.bind(this);
    return {
      show: true,
      hmUploadVisible: false,
      oldRow: {},
      newRow: {},
      parentRow: {},
      placeholder: "请输入手机号",
      queryType: "memberMobile",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      currentListItem: null,
      changeBgDialogVisible: false,
      setMemberDialogVisible: false,
      currentAgentRow: {},
      ruleFormMember: {
        memberMobile: "",
        memberName: "",
        memberSex: "",
        memberBirthday: "",
        memberRemark: ""
      },
      ruleForm: {
        relationshipAdjustment: "",
        singleGetcashUpperLimit: "",
        selfChangeType: "",
        changeType: ""
      },
      rules: {
        relationshipAdjustment: [
          {
            required: true,
            message: "请选择关系调整!",
            trigger: "blur"
          },
          {
            required: true,
            validator: adjustmentFunc,
            trigger: "blur"
          }
        ],
        selfChangeType: [
          {
            required: true,
            message: "请选择奖励调整方式!",
            trigger: "blur"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          }
        ],
        changeType: {
          required: true,
          message: "请选择下级奖励调整方式!",
          trigger: "blur"
        },
        memberMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        },
        memberName: [
          {
            required: true,
            message: "请输入会员姓名",
            trigger: "blur"
          },
          {
            required: true,
            min: 1,
            max: 10,
            message: "字数限制1-10之间",
            trigger: "blur"
          }
        ]
      },
      changeType: "notChange",
      type: "",
      memberInfo: [],
      addAgentList: [],
      keyWord: "",
      title: "",
      dialogVisible: false,
      searchCondition: {},
      currentPage: 1,
      currentAgent: {},
      currentAgentType: "",
      pageSize: 10,
      list: [],
      total: 0,
      AgentTitleList: [],
      row: {}
    };
  },
  computed: {},
  watch: {
    // total: {
    //   handler(val) {
    //     if (
    //       val == (this.currentPage - 1) * this.pageSize &&
    //       this.pageTotal != 0
    //     ) {
    //       this.currentPage -= 1;
    //       this.queryList();
    //     }
    //   },
    //   deep: true
    // }
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryAgentTitleList();
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    async queryAgentTitleList() {
      let params = {
        pageNo: 1,
        pageSize: 99
      };
      const { result } = await this.$store.dispatch(
        "queryAgentTitleList",
        params
      );
      this.AgentTitleList = result.records;
    },
    async searchAgent() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        keyWords: this.keyWord
      };
      const { result } = await this.$store.dispatch("queryAgentList", params);
      if (result.records.length > 0) {
        this.memberInfo = result.records;
      }
    },
    async queryMemberList() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        queryType: this.queryType,
        keyword: this.keyWord,
        isAgentSelect: "yes"
      };
      const { result } = await this.$store.dispatch(
        "queryMemberMgtList",
        params
      );

      this.memberInfo = result.records;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryAgentList", params);
      const { records, total } = result;
      records.forEach(v => {
        v.disabled = true;
        v.Level = this.SectionToChinese(v.agentLevel);
        v.isParent = v.isParent === "yes" ? true : false;
        v.parentRewardRatio = v.parentRewardRatio ? v.parentRewardRatio : "";
      });
      this.list = records;
      this.total = total;
    },
    changeListItemBg(row, type) {
      if (!row.disabled) {
        this.currentAgentType = type;
        this.currentListItem = row;
        this.hmUploadVisible = true;
      }
    },
    changeBg(row, type) {
      this.currentAgentRow = row;
      this.currentAgentType = type;
      this.hmUploadVisible = true;
    },
    cancleUpload() {
      this.hmUploadVisible = false;
    },
    hmUploadSuccess(res) {
      if (this.currentAgentType === "agentBgp") {
        this.currentAgentRow.agentBgp = res;
      } else if (this.currentAgentType === "agentLogo") {
        this.currentAgentRow.agentLogo = res;
      } else if (this.currentAgentType === "listItemAgentLogo") {
        this.currentListItem.agentLogo = res;
      } else if (this.currentAgentType === "listItemAgentBgp") {
        this.currentListItem.agentBgp = res;
      }
      this.hmUploadVisible = false;
    },
    // queryList() {
    //   let params = {
    //     pageNo: this.currentPage,
    //     pageSize: this.pageSize
    //   };
    //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

    //   Object.assign(params, searchCondition);
    //   return this.$store.dispatch("queryAgentList", params);
    // },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    relationshipAdjustmentChange() {
      this.memberInfo = [];
    },
    load(tree, treeNode, resolve) {
      const { shareAgentId } = tree;

      resolve([]);
      this.$store
        .dispatch("queryAgentList", {
          parentAgentId: shareAgentId
        })
        .then(res => {
          if (res.code === "0" && res.result.records.length) {
            res.result.records.forEach(v => {
              v.hasChildren = Boolean(v.isParent);
              v.disabled = true;
              v.Level = this.SectionToChinese(v.agentLevel);
              v.isParent = v.isParent === "yes" ? true : false;
              v.parentRewardRatio = v.parentRewardRatio
                ? v.parentRewardRatio
                : "";
            });
            resolve(res.result.records);
          } else {
            resolve([]);
          }
        });
    },
    filterGt0OrFixed2(prop, i, row) {
      if (row.agentLevel === 1) {
        this.list[i][prop] = this.list[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        this.list[i][prop] = this.list[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.list[i][prop] = this.list[i][prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
        this.list[i][prop] = this.list[i][prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
        ); //限制只能输入两个小数
        if (this.list[i][prop].indexOf(".") < 0 && this.list[i][prop] != "") {
          //首位是0的话去掉
          this.list[i][prop] = parseFloat(this.list[i][prop]);
        }
      } else {
        row[prop] = row[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        row[prop] = row[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        row[prop] = row[prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
        row[prop] = row[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
        if (row[prop].indexOf(".") < 0 && row[prop] != "") {
          //首位是0的话去掉
          row[prop] = parseFloat(row[prop]);
        }
      }
    },
    filterGt0OrFixed22(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed222(prop, i) {
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addAgentList[i][prop].indexOf(".") < 0 &&
        this.addAgentList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addAgentList[i][prop] = parseFloat(this.addAgentList[i][prop]);
      }
    },
    edit(row) {
      if (!row.disabled) {
        if (
          (this.oldRow.parentRewardRatio === "" &&
            row.parentRewardRatio === "") ||
          row.isParent === false
        ) {
          if (row.actualRewardRatio > 100) {
            this.$message({
              type: "warning",
              message: "分得上级代理奖励比例不得超过100"
            });
          } else {
            this.editUpdate(row);
          }
        } else {
          this.title = "提示";
          this.type = "isAdjustment";
          this.dialogVisible = true;
          this.row = row;
        }
      } else {
        row.disabled = !row.disabled;
        // this.list = [...this.list];
        this.oldRow = JSON.parse(JSON.stringify(row));
      }
    },
    add() {
      this.type = "add";
      this.dialogVisible = true;
      this.title = "新建一级代理";
    },
    SectionToChinese(section) {
      let chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      ];
      let chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      let strIns = "",
        chnStr = "";
      let unitPos = 0;
      let zero = true;
      while (section > 0) {
        let v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    filterGt0OrFixedMobile(prop) {
      if (/^1[0-9]{10}$/.test(this[prop])) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    changeRatio(ratio, i) {
      let val = (this.parentRow.actualRewardRatio / 100) * (ratio / 100) * 100;
      this.addAgentList[i].actualRewardRatio = val.toFixed(2);
      this.$forceUpdate();
    },
    addLowerLevel(row) {
      this.parentRow = row;
      this.type = "lowerLv";
      this.dialogVisible = true;
      this.title = "新增下级";
    },
    adjustment(row) {
      this.row = row;
      this.type = "adjustment";
      this.title = "关系调整";
      this.dialogVisible = true;
    },
    async editUpdate(row) {
      const { code } = await this.$store.dispatch("editShareAgent", row);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        setTimeout(() => {
          this.rest();
        }, 0);
        this.dialogVisible = false;
        this.list = [];
        this.queryList();
      }
    },
    deleteAgent(row) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          row.delFlag = "1";
          this.editUpdate(row);
          // this.$store.dispatch("editShareAgent", row).then(res => {
          //   if (res.code === "0") {
          //     this.$message({
          //       type: "success",
          //       message: "操作成功"
          //     });
          //     this.list = [];
          //     this.queryList();
          //   }
          // });
        })
        .catch(() => {});
    },
    searchMember() {
      this.queryMemberList();
    },

    createdMember() {
      this.setMemberDialogVisible = true;
    },
    resetRuleForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.rest();
      }, 0);
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleFormMember;

        this.$store.dispatch("addMemberMgt", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.setMemberDialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm(formName);
            }, 0);
          }
        });
      }
    },
    confirmAdd(v) {
      let flag = true;

      if (this.parentRow.centerId === v.centerId) {
        flag = false;
      }
      this.addAgentList.map(item => {
        if (v.centerId === item.centerId) {
          flag = false;
        }
      });

      if (flag) {
        let params = {
          centerId: v.centerId,
          agentPhone: v.memberMobile,
          agentName: v.memberName,
          sourceType: v.sourceType,
          storeCode: v.storeCode,
          actualRewardRatio: "",
          agentShopName: "",
          agentLogo:
            "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586165506119-7d198fe3-61e0-486a.png",
          agentBgp:
            "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586222286680-47bab015-1552-4f79.png"
        };
        this.addAgentList.push(params);
      }
    },
    remove(i) {
      this.addAgentList.splice(i, 1);
    },
    async addAgent(addAgentList) {
      const { code } = await this.$store.dispatch(
        "addShareAgent",
        addAgentList
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        setTimeout(() => {
          this.rest();
        }, 0);
        this.dialogVisible = false;
        this.list = [];
        this.queryList();
      }
    },
    async save(formName) {
      if (this.type === "add") {
        if (this.addAgentList.length < 1) {
          this.$message({
            type: "warning",
            message: "请先选择代理人"
          });
        } else {
          let show = false;
          let beyond = false;
          this.addAgentList.map(v => {
            if (!v.agentTitleId || !v.actualRewardRatio) {
              show = true;
            } else {
              if (v.actualRewardRatio > 100) {
                beyond = true;
              }
            }
          });
          if (show) {
            this.$message({
              type: "warning",
              message: "请先选择代理头衔或者填写实际比例！"
            });
          } else {
            if (beyond) {
              this.$message({
                type: "warning",
                message: "实际奖励比例不能超过100！"
              });
            } else {
              this.addAgent(this.addAgentList);
            }
          }
        }
      } else if (this.type === "isAdjustment") {
        this.row.changeType = this.changeType;
        this.editUpdate(this.row);
      } else if (this.type === "lowerLv") {
        let show = false;
        let validationRatio = false;
        this.addAgentList.forEach(v => {
          v.parentAgentId = this.parentRow.shareAgentId;
          if (!v.agentTitleId || !v.actualRewardRatio) {
            show = true;
          } else {
            if (v.parentRewardRatio > 100) {
              validationRatio = true;
            }
          }
        });
        if (show) {
          this.$message({
            type: "warning",
            message: "请先选择代理头衔或者填写实际比例！"
          });
        } else {
          if (validationRatio) {
            this.$message({
              type: "warning",
              message: "分得上级代理奖励比例不得超过100"
            });
          } else {
            this.addAgent(this.addAgentList);
          }
        }
      } else if (this.type === "adjustment") {
        const valid = await this.$refs[formName].validate();
        if (valid) {
          let params = this.ruleForm;
          if (params.relationshipAdjustment === "dingji") {
            this.row.parentAgentId = "-";
          } else {
            this.row.parentAgentId = this.memberInfo[0].shareAgentId;
          }
          if (params.selfChangeType === "change") {
            this.row.parentRewardRatio = params.singleGetcashUpperLimit;
          }
          Object.assign(this.row, params);
          this.editUpdate(this.row);
        }
      }

      // if (this.type === "isAdjustment") {
      //   this.queryList();
      //   this.dialogVisible = false;
      // }
    },
    rest() {
      this.row = {};
      this.addAgentList = [];
      this.keyWord = "";
      this.memberInfo = [];
      if (this.type === "adjustment") {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.member-body {
  width: 300px;
  padding: 5px 0;
}
.agent {
  font-family: PingFang SC;
  font-weight: 500;
  // font-size: 14px;
  // height: 32px;
  color: #222;
}

.agent-img-wrapper {
  position: relative;
  img {
    width: 100%;
  }
  .tips {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 15px;
      color: #222;
    }
  }
}
</style>
